/**
 * Monthly Worker AP is intentionally independent from the legacy
 * maintenance/monthlyWorker payment endpoints.
 */
const monthlyWorkerAP = {
  monthlyWorkerAPCurrentPeriod: "/accountPayable/monthlyWorkerAP/currentPeriod",
  monthlyWorkerAPPeriods: "/accountPayable/monthlyWorkerAP/periods",
  monthlyWorkerAPExport: "/accountPayable/monthlyWorkerAP/export",
  monthlyWorkerAPPeriodOptions: "/accountPayable/monthlyWorkerAP/periodOptions",
  monthlyWorkerAPPreview: "/accountPayable/monthlyWorkerAP/preview",
  monthlyWorkerAPPeriod: "/accountPayable/monthlyWorkerAP/period",
  monthlyWorkerAPConfirmMaintenance: "/accountPayable/monthlyWorkerAP/confirmMaintenance",
  monthlyWorkerAPConfirmPrecheck: "/accountPayable/monthlyWorkerAP/confirmPrecheck",
  monthlyWorkerAPGenerate: "/accountPayable/monthlyWorkerAP/generate",
  monthlyWorkerAPRegenerateVendor: "/accountPayable/monthlyWorkerAP/regenerateVendor",
  monthlyWorkerAPPush: "/accountPayable/monthlyWorkerAP/push",
  monthlyWorkerAPPeriodDeleteCheck: "/accountPayable/monthlyWorkerAP/periodDeleteCheck",
  monthlyWorkerAPDeletePeriod: "/accountPayable/monthlyWorkerAP/period",
  monthlyWorkerAPSupervisors: "/accountPayable/monthlyWorkerAP/supervisors",
  monthlyWorkerAPVendors: "/accountPayable/monthlyWorkerAP/vendors",
  monthlyWorkerAPDetails: "/accountPayable/monthlyWorkerAP/details",
  monthlyWorkerAPClocks: "/accountPayable/monthlyWorkerAP/clocks",
};

export default monthlyWorkerAP;
